import { render, staticRenderFns } from "./MiscellaneousServices.vue?vue&type=template&id=18528bae&"
import script from "./MiscellaneousServices.vue?vue&type=script&lang=js&"
export * from "./MiscellaneousServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports